import type { AxiosRequestConfig } from 'axios'
import {
  getLoginStatus,
  getTokenFromDisk,
} from '@/utils/auth'
import { LoginStatusEnum } from '@/store/modules/user'
import { redirectToLogin } from '@/utils'
import { openLogoutMsgBox } from '@/utils/message'

export async function authInterceptor (config: AxiosRequestConfig) {
  const loginStatus = await getLoginStatus()
  if (loginStatus === LoginStatusEnum.Login) {
    // 需要放在内存中, 这样其他 Tab 注销登录后, 其他 Tab 页可感知到 token 已失效
    const token = getTokenFromDisk()
    if(config.headers) {
      config.headers['Authorization'] = config.headers['Authorization'] ?? token
    } else {
      config.headers = { Authorization: token }
    }
  } else {
    if (loginStatus === LoginStatusEnum.OtherUserHasLoginFromOtherTab) {
      window.location.reload()
    } else if (loginStatus === LoginStatusEnum.NeverLogin) {
      redirectToLogin()
    } else {
      openLogoutMsgBox()
    }
  }

  return config
}
